export default __webpack_public_path__ + "static/media/team.af53aa6e.png";